import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function getVendors() {
  return query(gql`
    query Vendors {
      vendors {
        id
        logo_path
        description
        full_name
        display_name
        logo_path_color
        logo_path_black
        logo_path_white
        branding
        is_rental
        is_sparx
        website_link
      }
    }
  `)
}

export async function deleteApprovedVendor(payload) {
  return mutate(
    payload,
    gql`
      mutation Delete_approved_vendors($propertyId: Int!, $vendorId: Int!) {
        delete_approved_vendors(property_id: $propertyId, vendor_id: $vendorId) {
          vendor {
            id
          }
        }
      }
    `,
  )
}
